import GlossaryInfo from "@/components/GlossaryInfo";
import type { HealthColumn } from "./StockHealthCells";

// The glossary term behind each health column with an explanation.
const TERMS: Partial<Record<HealthColumn["key"], string>> = {
  doc: "soh-doc",
  stockout: "projected-out-of-stock",
};

// The (i) after a health column's label; nothing for columns without an explanation.
export default function ColumnInfo({ columnKey }: { columnKey: HealthColumn["key"] }) {
  const termId = TERMS[columnKey];
  return termId ? <GlossaryInfo termId={termId} /> : null;
}
